module.exports = __webpack_public_path__ + "static/media/11GalleryPuppets.93b685ae.jpeg";